module.exports = __webpack_public_path__ + "images/dzradio238914.jpg";


//////////////////
// WEBPACK FOOTER
// ./cms/client/images/dzradio.jpg
// module id = 63
// module chunks = 2